import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Southampton() {
  return <CityManagementPage config={allCityConfigs.southampton} />;
}